<template>
    <form class="participation-form" :class="{ 'summary-mode' : showSummary && !isDesktop }" :novalidate="true">
        <transition name="fade">
            <Notifications v-if="(notificationData && !modalStatus) || (notificationData && notificationData.type == 'info')"
                :msg-type="notificationData.type"
                :msg-text="notificationData.text"

            />
        </transition>
        <FormSummary v-if="showSummary" :summary-data="summaryData"/>
        <div v-else class="w-100 d-flex flex-column">
            <h3 class="submission-title"> {{ kStrings.kPARTICIPATION_DETAILS }} </h3>
            <div class="input-wrapper">
                <input v-model="name" id="userName" type="text" maxlength="50" class="normal-input" required>
                <label for="userName"> {{ kStrings.kGLOB_NAME }} </label>
            </div>
            <div class="input-wrapper">
                <SelectVue2 
                    v-model="selectedCountry" 
                    :options="countryOptions" 
                    :selected-default="defaultCountry" 
                    :input-label="kStrings.kCOUNTRY"
                    class="disabled"
                />
            </div>
            <SocialNetworkPicker v-if="requireSocialInfo" v-model="selectedSocial"/>
            <div v-if="linkErrorMsg" class="mt-2 mb-3" style="color: #d90000;">{{ linkErrorMsg }}</div>
            <div v-if="videoUploadMode" class="thumb-picker">
                <div class="input-wrapper file-upload-field" :class="{ 'disabled' : ignoreThumbnailCheck }">
                    <input type="file" accept="image/jpg, image/jpeg, image/png" class="custom-file-input" @change="changeBlockThumbnail" id="blockThumbnailUpload" :disabled="ignoreThumbnailCheck"/>
                    <label class="locked-pos" :class="{'valid' : thumbnailFileLabel }" for="blockThumbnailUpload"> {{ !thumbnailFileLabel ? kStrings.kSET_THUMBNAIL_PHOTO : thumbnailFileLabel }} </label>
                    <i :class="[ thumbnailFileLabel ? 'ecom-sucess' : 'ecom-info' ]"/>
                </div>
                <div class="ignore-thumb-wrapper">
                    <input v-model="ignoreThumbnailCheck" type="checkbox" name="ignoreThumbnailCheck" id="ignoreThumbnailCheck">
                    <label for="ignoreThumbnailCheck" class="ignore-thumb-description"> {{ kStrings.kTHUMBNAIL_IGNORE_DESCRIPTION }} </label>
                </div>
            </div>
            <!-- normal pastime && no text description -->
            <div v-if="!requireTextDescription && !isTypeRecipe" class="button-wrapper">
                <h4 class="input-title"> {{ kStrings.kUSED_PRODUCTS + ':' }} </h4>
                <button v-if="!selectedProductsList" class="pastime-button" @click.prevent="modalControl(true, 'catalogCart')"> {{ kStrings.kADD }} </button>
                <div v-else class="submission-editor">
                    <i class="ecom-sucess"/>
                    <p> {{ selectedProductsList.length + ' ' + kStrings.kX_PRODUCTS_SAVED }} </p>
                    <span @click.prevent="modalControl(true, 'catalogCart')"> {{ kStrings.kGLOB_EDIT }} </span>
                </div>
            </div>
            <!-- normal pastime && text description -->
            <div v-else-if="requireTextDescription && !isTypeRecipe" class="button-wrapper">
                <h4 class="input-title"> {{ kStrings.kINFO_SLASH_PRODUCTS + ':' }} </h4>
                <button v-if="!descriptionForm" class="pastime-button" @click.prevent="modalControl(true, 'descriptionForm');"> {{ kStrings.kADD }} </button>
                <div v-else class="submission-editor">
                    <i class="ecom-sucess"/>
                    <p> {{ kStrings.kGLOB_SAVED }} </p>
                    <span @click.prevent="modalControl(true, 'descriptionForm'); "> {{ kStrings.kGLOB_EDIT }} </span>
                </div>
            </div>
            <!-- recipe pastime -->
            <div v-else class="button-wrapper">
                <h4 class="input-title"> {{ kStrings.kRECIPE_INSTRUCTIONS_INGREDIENTS + ':' }} </h4>
                <button v-if="!recipeForm" class="pastime-button" @click.prevent="modalControl(true, 'recipeForm', true);"> {{ kStrings.kADD }} </button>
                <div v-else class="submission-editor">
                    <i class="ecom-sucess"/>
                    <p> {{ kStrings.kGLOB_SAVED }} </p>
                    <span @click.prevent="modalControl(true, 'recipeForm', true);"> {{ kStrings.kGLOB_EDIT }} </span>
                </div>
            </div>
            <div class="button-wrapper submit-wrapper">
                <button class="pastime-button submit red-theme" @click.prevent="canRegister && submitHandler()" :disabled="!enableRegistration"> {{ kStrings.kPARTICIPATE }} </button>
                <div v-if="canRegisterMotive" :style="{textAlign: 'center', justifyContent: 'center'}" v-html="canRegisterMotive"></div>
                <div v-else class="terms-wrapper">
                    <input v-model="terms" type="checkbox" name="termsAccept" id="termsAccept">
                    <label for="termsAccept" class="terms-description"> {{ kStrings.kPASTIMES_AGREEMENT }} </label>
                </div>
            </div>
        </div>
    </form>
</template>

<script>

import SelectVue2 from '@/components/Muffin/SelectVue2';
import FormSummary from '@/components/Pastimes/Desktop/partials/FormSummary';

import SocialNetworkPicker from '@/components/Pastimes/Desktop/partials/SocialNetworkPicker';

import Notifications from '@/components/Pastimes/Desktop/partials/Notifications';

import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';
import sharedApi from '@/api/sharedApi';
import request from '@/Utilities/httpRequest';

export default {
    store,
    name: 'ParticipationForm',
    components: {
        SelectVue2,
        FormSummary,
        SocialNetworkPicker,
        Notifications
    },
    props: {},
    data() {
        return {
            // registration form v-models
            name: null,
            selectedCountry: '',
            selectedSocial: {
                type: 'linkoff',
                link: ''
            },
            terms: false,
            generatedCdnUrls: [],
            generatedBlockThumbnail: null,
            ignoreThumbnailCheck: false,
            showSummary: false,
            linkErrorMsg: null,
            submitProcess: false,
            thumbnailFileLabel: null,
            lockSubmit: false
        }
    },
    computed: {
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        isLoading() {
            return this.$store.getters.loading;
        },
        registerValidation(){
            return this.$store.getters.registerValidation;
        },
        alreadyRegistered() {
            return this.registerValidation?.alreadyRegistered ?? false; 
        },
        canRegister(){ 
            let canRegister = this.registerValidation?.canRegister ?? false;
            return canRegister && !this.alreadyRegistered;
        },
        canRegisterMotive(){
            return !this.canRegister ? this.registerValidation?.motive ?? null : null;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        modalStatus() {
            return this.$store.getters.modalStatus;
        },
        customerInfo() {
            return this.$store.getters['registrationPage/customerInfo'];
        },
        isLogged() {
            return this.$store.getters.isLogged;
        },
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        singleMedia() {
            return this.pastimeInfo.detailedInfo.mediaLayoutSize == 1;
            // false;
        },
        videoUploadMode() {
            // for now only one
            return this.singleMedia && this.pastimeInfo.baseInfo.layoutType == 'ONEVIDEO';
        },
        validPhone() {
            return this.$store.getters.validPhone;
        },
        requirePhoneValidationToRegister() {
            return this.$store.getters.registerValidation?.phoneValidation ?? false;
        },
        requireSMSValidation() {
            return this.requirePhoneValidationToRegister && !this.validPhone;
        },
        requireUsedProducts() {
            return this.pastimeInfo.baseInfo.requireUsedProducts;
        },
        requireSocialInfo() {
            return this.pastimeInfo.baseInfo.requireSocialInfo;
        },
        requireTextDescription() {
            let requireTextDescription = this.pastimeInfo.baseInfo.requireTextDescription;
            if (typeof requireTextDescription == "boolean") {
                return this.pastimeInfo.baseInfo.requireTextDescription;
            }

            return true;
        },
        countryOptions() {
            const userInfo = this.customerInfo.info;
            return [
                {
                    id: userInfo.country,
                    text: userInfo.countryName,
                    value: userInfo.country,
                }
            ];
        },
        defaultCountry() {
            return !isEmpty(this.customerInfo) ? this.customerInfo.currentStore : null;
        },
        isTypeRecipe() {
            return this.pastimeInfo.detailedInfo.isRecipe;
            //return false;
        },
        modalData() {
            return this.$store.getters.modalData;
        },
        descriptionForm() {
            const data = this.$store.getters['registrationPage/descriptionForm'];
            if(!this.requireTextDescription || (this.requireUsedProducts && !this.selectedProductsList) || !data.title || !data.description) {
                return null;
            }
            return !isEmpty(data) ? data : null;
        },
        recipeForm() {
            if(this.requireUsedProducts && !this.selectedProductsList) {
                return null;
            }
            const data = this.$store.getters['registrationPage/recipeForm'];
            return !isEmpty(data) ? data : null;
        },
        selectedProductsList() { // store list to submit
            const data = this.$store.getters['registrationPage/selectedProductsList'];
            return !isEmpty(data) ? data : null
        },
        mediaGridUpload() {
            return this.$store.getters['registrationPage/mediaGridUpload'];
        },
        mediaDataToSubmit() {
            let data = [];
            if(!isEmpty(this.mediaGridUpload)) {
                this.mediaGridUpload.forEach((element, index) => {
                    //data[index] = element.mediaData.src;
                    data[index] = element.mediaData.file;
                });
            }
            
            return data;
        },
        productsDataToSubmit() {
            let data = [];
            if(!isEmpty(this.selectedProductsList)) {
                this.selectedProductsList.forEach((element, index) => {
                    data[index] = {
                        groupId: element.groupId,
                        sku: element.selectedSku,
                        quantity: element.quantity
                    };
                });
            }

            return data;
        },
        formDataToSubmit() {
            let formObject = this.isTypeRecipe ? this.recipeForm : this.descriptionForm;
            if(isEmpty(formObject)) {
                return [];
            }
            
            if(!this.isTypeRecipe) {
                delete formObject.selectedProductsList;
                return formObject;
            }
            
            let allEntries = Object.entries(formObject).map(entry => {
                return {[entry[0]]: entry[1]};
            });

            delete allEntries['selectedProductsList'];
            return allEntries;
        },
        requiredMediaCount() {
            return this.pastimeInfo.detailedInfo.mediaLayoutSize;
        },
        enableRegistration() {
            if(this.lockSubmit) {
                return false;
            }
            
            if(this.submitProcess || this.isLoading){
                return false;
            }
            if(!this.canRegister){
                return false;
            }
            let checkTerms = this.terms;
            let checkIdForm = this.name && this.selectedCountry;
            let checkTextDescriptionForm = (!this.isTypeRecipe || !this.requireTextDescription) || this.descriptionForm;
            let checkRecipeForm = !this.isTypeRecipe || this.recipeForm;
            let checkSocial = !this.requireSocialInfo || (!this.selectedSocial || this.selectedSocial.type == 'linkoff' || (this.selectedSocial && this.selectedSocial.link));
            let checkSelectedProductsList = !this.requireUsedProducts || (this.requireUsedProducts && !isEmpty(this.selectedProductsList));
            let checkMedia = this.mediaGridUpload.length == this.requiredMediaCount;
            
            if(this.selectedSocial || this.selectedSocial.type == 'linkoff' && this.linkErrorMsg){
                this.linkErrorMsg = null;
            }
            
            let checkBlockThumbnail = !this.videoUploadMode || (this.videoUploadMode && (this.ignoreThumbnailCheck || this.blockThumbnail))
            
            return checkTerms && checkIdForm && (checkTextDescriptionForm || checkRecipeForm) && checkSocial && checkSelectedProductsList && checkMedia && checkBlockThumbnail;
        },
        urls() {
            return this.$store.getters.urls;
        },
        summaryData() {
            let selectedCountryObject = this.countryOptions.find(elm => elm.value == this.selectedCountry);
            //console.log(selectedCountryObject);
            return {
                name: this.name,
                country: selectedCountryObject.text,
                social: this.selectedSocial,
                content: this.isTypeRecipe ? this.recipeForm : this.descriptionForm,
                participantListPageLink: this.isDesktop ? this.urls.pastimeUrl : this.urls.participantsPage,
                personalPageLink: '',
                productList: this.selectedProductsList
            }
        },
        notificationData() {
            return this.$store.getters['registrationPage/notificationData'];
        },
        blockThumbnail() {
            return this.$store.getters['registrationPage/blockThumbnail'];
        }
    },
    watch: {
        showSummary(value) {
            if(value) {
                this.setMaxSummaryHeight();
            }
        },
        ignoreThumbnailCheck(value) {
            if(value) {
                this.changeBlockThumbnail(null);
            }
        }
    },
    created() {},
    mounted() {
        this.$nextTick(() => {
            this.formSetup();
            if(this.isDesktop) {
                window.removeEventListener("resize", this.setMaxSummaryHeight);
                window.addEventListener("resize", this.setMaxSummaryHeight);
            }
        });
    },
    methods: {
        formSetup() {
            // shared fields between pastime types
            this.setDefaults();
        },
        setDefaults() {
           if(this.customerInfo && !isEmpty(this.customerInfo.info)) {
               this.name = this.customerInfo.info.firstname + ' ' + this.customerInfo.info.lastname;
           } 
           
           this.selectedCountry = this.defaultCountry ? this.defaultCountry : this.countryOptions[0].value.toUpperCase();
           
           if(!this.requirePhoneValidationToRegister) {
               this.$store.dispatch('setValidPhone', true);
           }
        },
        modalControl(status = false, context = '', isMixType = false) {
            // isMixType -> modal can have multiple content types with a more complex flow
            this.$store.dispatch('setModalStatus', {status: status, context: context, isMixType: isMixType});
        },
        async generateBlockThumbnailUrl() {
            let params = {
                socialPastimeId: this.pastimeInfo.baseInfo.id,
            }

            try {
                const {data} = await request.post(this.urls.generateBlockThumbnailUrl, params, false);
                let hasError = data.hasError || isEmpty(data);
                if(!hasError) {
                    let cdnUrl = await sharedApi.uploadFile(data.uploadUrl, data.name, this.blockThumbnail, false);
                    if(!isEmpty(cdnUrl)){
                        this.generatedBlockThumbnail = cdnUrl;
                    } else {
                        sharedApi.logError(this.kStrings.kMEDIA_UPLOAD_FAILED);
                        this.$store.dispatch('registrationPage/loadNotification', {
                            type: 'error',
                            text: this.kStrings.kMEDIA_UPLOAD_FAILED,
                            duration: 10000
                        });
                    }
                } else {
                    sharedApi.logError(this.kStrings.kMEDIA_UPLOAD_FAILED);
                    this.$store.dispatch('registrationPage/loadNotification', {
                        type: 'error',
                        text: this.kStrings.kMEDIA_UPLOAD_FAILED,
                        duration: 10000
                    });
                }
                
            } catch (e) {
                sharedApi.logError(e);
                this.$store.dispatch('registrationPage/loadNotification', {
                    type: 'error',
                    text: this.kStrings.kTHUMBNAIL_UPLOAD_FAILED,
                    duration: 10000
                });

            } finally {
                this.$store.dispatch('setLoading', false);
                this.submitProcess = false;
            }
            
        },
        
        async generateGalleryUrls() {
            this.submitProcess = true;
            this.$store.dispatch('setLoading', true);
            if(this.videoUploadMode && this.blockThumbnail) {
                await this.generateBlockThumbnailUrl();
            }
            
            let params = !this.videoUploadMode ? {
                socialPastimeId: this.pastimeInfo.baseInfo.id,
                imgData: this.mediaDataToSubmit,
            } : {
                socialPastimeId: this.pastimeInfo.baseInfo.id,
                videoData: this.mediaDataToSubmit,
            };

            try {
                const {data} = await request.post(this.urls.generateGalleryUrls, params, false);
                let hasError = data.hasError || isEmpty(data);
                console.log('CDN url data: ', data);
                if(!hasError) {
                    let cloudFlareUrls = await sharedApi.uploadFileArray(data, this.mediaDataToSubmit, this.videoUploadMode);
                    if(!isEmpty(cloudFlareUrls)){
                        this.generatedCdnUrls = cloudFlareUrls;
                        this.submitRegistration(); 
                    } else {
                        sharedApi.logError(this.kStrings.kMEDIA_UPLOAD_FAILED);
                        this.$store.dispatch('registrationPage/loadNotification', {
                            type: 'error',
                            text: this.kStrings.kMEDIA_UPLOAD_FAILED,
                            duration: 10000
                        });
                        this.submitProcess = false;
                    }
                } else {
                    let errorMessage = this.kStrings.kMEDIA_UPLOAD_FAILED;
                    if(data.hasOwnProperty('lockSubmit') && data.lockSubmit) {
                        this.lockSubmit = true;
                        errorMessage = data.message;
                    } 
                    
                    sharedApi.logError(this.kStrings.kMEDIA_UPLOAD_FAILED);
                    this.$store.dispatch('registrationPage/loadNotification', {
                        type: 'error',
                        text: errorMessage,
                        duration: 10000
                    });
                    this.submitProcess = false;
                }
                
            } catch (e) {
                sharedApi.logError(e);
                this.$store.dispatch('registrationPage/loadNotification', {
                    type: 'error',
                    text: this.kStrings.kMEDIA_UPLOAD_FAILED,
                    duration: 10000
                });
                this.submitProcess = false;

            } finally {
                this.$store.dispatch('setLoading', false);
                //this.submitProcess = false;
            }
        },
        
        async submitRegistration() {
            this.$store.dispatch('setLoading', true);
            let params = {
                socialPastimeId: this.pastimeInfo.baseInfo.id,
                customerId: this.customerInfo.info.customer_id,
                categoryId: this.pastimeInfo.detailedInfo.categoryId,
                social: this.selectedSocial,
                name: this.name,
                country: this.selectedCountry,
                photos: !this.videoUploadMode ? this.generatedCdnUrls : [],
                videos: this.videoUploadMode ? this.generatedCdnUrls : [],
                products: this.productsDataToSubmit,
                submissionForm: this.formDataToSubmit,
                blockThumbnail: this.generatedBlockThumbnail
            };

            try {
                const {data} = await request.post(this.urls.submitRegistration, params, false);
                let hasError = data.hasError;
                
                sharedApi.debug(data);
                if(hasError) {
                    this.$store.dispatch('registrationPage/loadNotification', {
                        type: 'error',
                        text: this.kStrings.kGLOB_ERROR_MSG,
                        duration: 10000
                    });
                }
                
                this.showSummary = !data.hasError;
                this.$store.dispatch('registrationPage/setForceHideEditButtons', !data.hasError);
                
            } catch (e) {
                sharedApi.logError(e);
                this.$store.dispatch('registrationPage/loadNotification', {
                    type: 'error',
                    text: this.kStrings.kGLOB_ERROR_MSG,
                    duration: 10000
                });
                
            } finally {
                this.$store.dispatch('setLoading', false);
                this.submitProcess = false;
            }
        },
        submitHandler() {
            const social = this.selectedSocial;
            if(social && social.type != 'linkoff' && !sharedApi.isValidUrl(social.link)){
                this.linkErrorMsg = this.kStrings.kENTER_A_VALID_URL;
                return;
            }
            this.linkErrorMsg = null;

            if(this.requireSMSValidation) {
                this.modalControl(true, 'smsValidation');
            } else {
                this.generateGalleryUrls();
            }
        },
        setMaxSummaryHeight() {
            if(this.isDesktop) {
                setTimeout(() => {
                    //let submissionSetupWrapper = document.getElementById('submissionSetupWrapper');
                    let mediaGalleryWrapper = document.getElementById('mediaGalleryWrapper');
                    let pastimeNotification = document.getElementById('pastimeNotification');
                    if (mediaGalleryWrapper) {
                        //let summaryContent = this.$refs.summaryContent.$el;
                        let summaryContent = document.getElementById('summaryContent');
                        if (summaryContent) {
                            let mediaGalleryWrapperHeight = mediaGalleryWrapper.offsetHeight;
                            if(mediaGalleryWrapperHeight) {
                                if(pastimeNotification) {
                                    summaryContent.style.maxHeight = mediaGalleryWrapperHeight - (pastimeNotification.offsetHeight + 118) + 'px';
                                } else {
                                    summaryContent.style.maxHeight = mediaGalleryWrapperHeight - 215 + 'px';
                                }
                            }
                        }
                    }
                }, 300);
            }
        },
        changeBlockThumbnail(event) {
            if(!event) { // ignorecheck
                this.thumbnailFileLabel = null;
                this.$store.dispatch('registrationPage/setBlockThumbnail', null);
                let blockThumbnailUpload = document.getElementById('blockThumbnailUpload');
                if(blockThumbnailUpload) {
                    blockThumbnailUpload.value = null;
                }
            } else {
                let _URL = window.URL || window.webkitURL;
                let file = event.target.files[0];
                if (file) {
                    let objectUrl = _URL.createObjectURL(file);
                    let img = new Image();
                    img.src = objectUrl;
                    img.onload = () => {
                        this.thumbnailFileLabel = file.name + ' - ' + img.width + ' x ' + img.height;
                        if ((img.width === img.height) && (img.width >= 600 && img.height >= 600)) {
                            this.$store.dispatch('registrationPage/setBlockThumbnail', file);
                            console.log('thumbnail ok to load');
                            // upload logic here
                        } else {
                            this.$store.dispatch('registrationPage/loadNotification', {
                                type: 'error',
                                text: this.kStrings.kSET_THUMBNAIL_PHOTO_ERROR,
                                duration: 6000
                            });
                            console.log(`fail! -> ${img.width} x ${img.height}`);
                            this.thumbnailFileLabel = null;
                            event.target.value = null;
                            this.$store.dispatch('registrationPage/setBlockThumbnail', null);
                        }

                        _URL.revokeObjectURL(objectUrl);
                    };
                } else {
                    this.thumbnailFileLabel = null;
                    event.target.value = null;
                    this.$store.dispatch('registrationPage/setBlockThumbnail', null);
                }
            }
        },
    }
};
</script>

<style scoped>

</style>